import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { createSetIsToastOpen } from 'src/app/Toast/redux/toast.actions'
import { translateNode } from 'src/localization/translateNode'
import { closeModal } from 'src/navigation/Lnk'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { CognitoChangePasswordRequest } from 'src/requests/cognitoChangePassword.request'
import { BackendErrorPayload } from 'src/utils/error.utils'

export const POST_COGNITO_CHANGE_PASSWORD_INIT =
  'auth/POST_COGNITO_CHANGE_PASSWORD_INIT'
export const POST_COGNITO_CHANGE_PASSWORD_SUCCESS =
  'auth/POST_COGNITO_CHANGE_PASSWORD_SUCCESS'
export const POST_COGNITO_CHANGE_PASSWORD_FAILURE =
  'auth/POST_COGNITO_CHANGE_PASSWORD_FAILURE'
export const CLEAR_COGNITO_CHANGE_PASSWORD_ERRORS =
  'auth/CLEAR_COGNITO_CHANGE_PASSWORD_ERRORS'

interface PostCognitoChangePasswordSuccessPayload {
  type: string
}

type PostCognitoChangePasswordFailurePayload = BackendErrorPayload<string>

export interface PostCognitoChangePasswordInitAction {
  type: typeof POST_COGNITO_CHANGE_PASSWORD_INIT
}
export interface PostCognitoChangePasswordSuccessAction {
  type: typeof POST_COGNITO_CHANGE_PASSWORD_SUCCESS
  payload: PostCognitoChangePasswordSuccessPayload
}
export interface PostCognitoChangePasswordFailureAction {
  type: typeof POST_COGNITO_CHANGE_PASSWORD_FAILURE
  payload: PostCognitoChangePasswordFailurePayload
}
export interface ClearCognitoChangePasswordErrors {
  type: typeof CLEAR_COGNITO_CHANGE_PASSWORD_ERRORS
}

export type PostCognitoChangePasswordActions =
  | PostCognitoChangePasswordInitAction
  | PostCognitoChangePasswordSuccessAction
  | PostCognitoChangePasswordFailureAction
  | ClearCognitoChangePasswordErrors

const createPostCognitoChangePasswordInitAction =
  (): PostCognitoChangePasswordInitAction => ({
    type: POST_COGNITO_CHANGE_PASSWORD_INIT,
  })

const createPostCognitoChangePasswordSuccessAction = (
  payload: PostCognitoChangePasswordSuccessPayload,
): PostCognitoChangePasswordSuccessAction => ({
  type: POST_COGNITO_CHANGE_PASSWORD_SUCCESS,
  payload,
})
const createPostCognitoChangePasswordFailureAction = (
  payload: PostCognitoChangePasswordFailurePayload,
): PostCognitoChangePasswordFailureAction => ({
  type: POST_COGNITO_CHANGE_PASSWORD_FAILURE,
  payload: payload,
})

export const createClearCognitoChangePasswordErrorsAction =
  (): ClearCognitoChangePasswordErrors => ({
    type: CLEAR_COGNITO_CHANGE_PASSWORD_ERRORS,
  })

export const postCognitoChangePassword = (
  body: Partial<CognitoChangePasswordRequest>,
): ThunkAction<
  Promise<void>,
  RootState,
  void,
  PostCognitoChangePasswordActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, PostCognitoChangePasswordActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createPostCognitoChangePasswordInitAction())
    return axios
      .post(
        `/change-password`,
        body,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          dispatch(createPostCognitoChangePasswordSuccessAction(response.data))
          dispatch(
            createSetIsToastOpen(true, {
              toastMessage: translateNode(
                'Success! Your password has been changed.',
              ),
            }),
          )
          dispatch(closeModal())
        },
        (err) => {
          dispatch(
            createPostCognitoChangePasswordFailureAction(err.response.data),
          )
        },
      )
  }
}
